import { render, staticRenderFns } from "./JoszakiTable.vue?vue&type=template&id=31792d1e"
import script from "./JoszakiTable.vue?vue&type=script&lang=js"
export * from "./JoszakiTable.vue?vue&type=script&lang=js"
import style0 from "./JoszakiTable.vue?vue&type=style&index=0&id=31792d1e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports